import {LabelToken} from '@github-ui/label-token'

interface LabelBadge {
  name: string
  color?: string
}

interface RenderLabelBadgesOptions {
  labels: LabelBadge[]
  /** Invoked with the label name when a label badge is clicked. When omitted the badges are static. */
  onSelect?: (labelName: string) => void
  /** Class applied to the filter button so each row can preserve its own link styling. */
  filterLinkClassName?: string
}

/**
 * Shared label badge renderer for dashboard list rows. Returns an array of
 * nodes suitable for `ListItemTitle`'s `trailingBadges`, so issue and
 * pull-request rows render labels identically instead of duplicating the map.
 */
export function renderLabelBadges({labels, onSelect, filterLinkClassName}: RenderLabelBadgesOptions) {
  return labels.map(label => {
    const token = (
      <LabelToken
        text={label.name}
        fillColor={label.color ? `#${label.color}` : undefined}
        style={{marginRight: '4px', cursor: onSelect ? 'pointer' : undefined}}
      />
    )

    if (!onSelect) {
      return <span key={label.name}>{token}</span>
    }

    return (
      <button
        key={label.name}
        type="button"
        className={filterLinkClassName}
        onClick={() => onSelect(label.name)}
        aria-label={`Filter by label ${label.name}`}
      >
        {token}
      </button>
    )
  })
}
